import { parseError } from 'utils/utils';
import apiService from 'services/apiService';
import Classroom from 'models/Classroom';
import { EvalType } from 'view/components/teacher/assignment/forms/Evaluation';
import { EvaluationEntry } from 'utils/types';
import StudentQuestion from 'models/StudentQuestion';

export class EvaluationService {
  private static instance: EvaluationService;

  public static get(): EvaluationService {
    if (!EvaluationService.instance) {
      EvaluationService.instance = new EvaluationService();
    }

    return EvaluationService.instance;
  }

  createEvaluation = async (
    type: EvalType,
    override_default: boolean,
    baseline: number,
    classroom?: string,
    district?: string,
    selectedStudents?: string[],
  ): Promise<Classroom> => {
    try {
      const response = await apiService.api.post('/evaluations/', {
        type: type,
        override_default: override_default,
        baseline: baseline,
        classroom: classroom,
        district: district,
        users: selectedStudents,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  getSubmissionById = async (submissionId: string): Promise<Classroom> => {
    try {
      const response = await apiService.api.get(
        `/evaluation-submissions/${submissionId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  getWidaQuestions = async (
    submissionId: string,
    wida_listening: string,
    wida_reading: string,
    wida_speaking: string,
    wida_writing: string,
  ): Promise<StudentQuestion[]> => {
    try {
      const response = await apiService.api.post(
        `/evaluation-submissions/${submissionId}/get-wida-questions/`,
        {
          listening: wida_listening,
          reading: wida_reading,
          speaking: wida_speaking,
          writing: wida_writing,
        },
      );
      return response.data.map((sq: any) =>
        StudentQuestion.fromServerStudentQuestion(sq),
      );
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  getLexileQuestions = async (
    submissionId: string,
    lexile_reading: string,
  ): Promise<StudentQuestion[]> => {
    try {
      const response = await apiService.api.post(
        `/evaluation-submissions/${submissionId}/get-lexile-questions/`,
        {
          lexile_reading: lexile_reading,
        },
      );
      return response.data.map((sq: any) =>
        StudentQuestion.fromServerStudentQuestion(sq),
      );
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  submitEvaluationRound = async (
    submissionId: string,
    questions: EvaluationEntry[],
    completed?: boolean,
  ): Promise<Classroom> => {
    try {
      const response = await apiService.api.patch(
        `/evaluation-submissions/${submissionId}/`,
        {
          questions: questions,
          completed: completed,
        },
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  deleteEvaluation = async (evaluationId: string): Promise<Classroom> => {
    try {
      const response = await apiService.api.delete(
        `/evaluations/${evaluationId}/`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };
}

const evaluationService = EvaluationService.get();
export default evaluationService;
